/***
*
*   BILLING
*   Change subscription, update card details or view past invoices
*
**********/

import React, { Fragment, useEffect, useState} from 'react';
import { AccountNav, Card, Form, Animate, useAPI } from 'components/lib';
import axios from 'axios';
import ReactTooltip from "react-tooltip";
import Style from './settings.module.scss';

export function Settings(props){

  const [domainData, setDomainData] = useState(null);

  // fetch
  const user = useAPI('/api/user');

  useEffect(async () => {
    if(user.data?.accounts[0]?.domain) {
      let dom = await getDomain(user.data?.accounts[0]?.domain);
      setDomainData(dom.data);
    }
  }, [user]);

  const getDomain = async (domain) => {
    const res = await axios({ 
      url: `/api/utility/domain/?domain=${domain}`,
      method: 'get',
    });

    return res;
  }

  return (
    <Fragment>
      <AccountNav />
      <Animate>
        <Card title='Información de tu cuenta' restrictWidth>
          { user?.data && domainData &&
          <div>
            <Form
              url='/api/utility/domain'
              method='POST'
              buttonText='Guardar Correo'
              data={{
                domain: {
                  label: 'Dominio del cual vas a enviar las campañas',
                  type: 'text',
                  required: true,
                  value: domainData?.name || '',
                },
              }}
              callback={ (res) => {
                  
                console.log(res)
              
              }}
            />
            <div 
              style={{ 
                borderRadius: '50%', 
                border: `1px solid ${domainData?.state && domainData?.state === 'unverified' ? '#e01010' : '#15eb39'}`, 
                width: '12px', 
                height: '12px', 
                position: 'absolute', 
                top: '46%', 
                left: '100%',
                background: `${domainData?.state && domainData?.state === 'unverified' ? '#e01010' : '#15eb39'}`,
                cursor: 'pointer'
              }}
              data-tip data-for='custom-class' data-event="click focus"
            />
            <ReactTooltip
              id="custom-class"
              className={ Style.extraClass }
              place='bottom'
              type={domainData?.state && domainData?.state === 'unverified' ? 'error' : 'success'}
              effect='solid'
              globalEventOff="click"
            >
              {domainData?.state && domainData?.state === 'unverified' ?
                <div>
                  <h4>Sigue los siguientes pasos para verificar tu dominio</h4>
                  <br/>
                  <div>1. Vaya a su proveedor de DNS Collapse</div>
                  <div>
                    {`Vaya al proveedor de DNS que utiliza para administrar ${domainData?.name} y agregue los siguientes registros DNS.`}
                  </div>
                  <br/>
                  <h5>
                  Los proveedores comunes incluyen:
                  </h5>
                  <ul>
                    <li>GoDaddy</li>
                    <li>NameCheap</li>
                    <li>Network Solutions</li>
                    <li>Rackspace Email & Apps</li>
                    <li>Rackspace Cloud DNS</li>
                    <li>Amazon Route 53</li>
                    <li>Digital Ocean</li>
                  </ul>
                  <br/>
                  <div>2. Agregar registros DNS para enviar Contraer</div>
                  <br/>
                  <ul>
                    <li>Type: TXT</li>
                    <li>{`Hostname: mailo._domainkey.${domainData?.name}`}</li>
                    <li>Enter This Value: k=rsa;</li>
                    <li>Current Value: p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6+Z59g1uYUA8KHcKkHrK6AzzcIlP0MxLy1nihnJQ51kPI1</li>
                    <li>L7WZrQeWDQzw9VpZltUwbjz/FAm2hi+E9myTyj41lRdWqusnZjlARdvxs1UmL7ObCcxJFMxYXhzLPeiV5k/VkMQq5+A6thji49RhTc</li>
                    <li>h5D2mk8yx3fACwz9J3/lsewIDAQAB</li>
                  </ul>
                </div> :
                <div>
                  Email Verificado
                </div>
              }
            </ReactTooltip>
          </div>
          }
        </Card>
      </Animate>
    </Fragment>
  );
}
